/**
 * An enumeration of all possible feature rights.  Use these as the key into the featureRights manager.
 */
// This SQL query will give you every feature right, formatted like JSON:
//
// select permissionKey + ': "' + permissionKey + '",' from Permissions order by permissionKey
//
// When a new feature right is added, you should only ever need to add it here.
const FeatureRight = {
    ADMIN: "ADMIN",
    APPROVE_RETENTION_POLICIES: "APPROVE_RETENTION_POLICIES",
    AUDITING_MANAGE: "AUDITING_MANAGE",
    BATCH_DELETE: "BATCH_DELETE",
    BATCH_MANAGE: "BATCH_MANAGE",
    BPM_ATTENDANCE_CONFIGURE: "BPM_ATTENDANCE_CONFIGURE",
    BPM_ATTENDANCE_SELF_CONFIGURE: "BPM_ATTENDANCE_SELF_CONFIGURE",
    BPM_BUSINESS_HOURS_CONFIGURE: "BPM_BUSINESS_HOURS_CONFIGURE",
    BPM_DESIGNER: "BPM_DESIGNER",
    BPM_HOLIDAYS_CONFIGURE: "BPM_HOLIDAYS_CONFIGURE",
    BPM_INSTANCE_DELETE: "BPM_INSTANCE_DELETE",
    BPM_INSTANCE_EDIT: "BPM_INSTANCE_EDIT",
    BPM_INSTANCE_RESTART: "BPM_INSTANCE_RESTART",
    BPM_JOB_MOVE: "BPM_JOB_MOVE",
    BPM_JOB_PRIORITY_SET: "BPM_JOB_PRIORITY_SET",
    BPM_JOB_QUEUE: "BPM_JOB_QUEUE",
    BPM_JOB_REDISTRIBUTE: "BPM_JOB_REDISTRIBUTE",
    BPM_JOB_USER_CLEAR: "BPM_JOB_USER_CLEAR",
    BPM_MODEL_ACTIVATE: "BPM_MODEL_ACTIVATE",
    BPM_MODEL_ASSIGN: "BPM_MODEL_ASSIGN",
    BPM_MODEL_DEACTIVATE: "BPM_MODEL_DEACTIVATE",
    BPM_MODEL_DELETE: "BPM_MODEL_DELETE",
    BPM_MODEL_EXPORT: "BPM_MODEL_EXPORT",
    BPM_MODEL_IMPORT: "BPM_MODEL_IMPORT",
    BPM_MODEL_MANAGE: "BPM_MODEL_MANAGE",
    BPM_MODEL_UNLOCK: "BPM_MODEL_UNLOCK",
    BPM_MONITORING: "BPM_MONITORING",
    BPM_QUEUE_VIEWS_CONFIGURE: "BPM_QUEUE_VIEWS_CONFIGURE",
    BPM_ROLE_PROXY_CONFIGURE: "BPM_ROLE_PROXY_CONFIGURE",
    BPM_SHIFTS_CONFIGURE: "BPM_SHIFTS_CONFIGURE",
    BPM_START_PROCESS_INSTANCE: "BPM_START_PROCESS_INSTANCE",
    CENTRAL_ADMIN: "CENTRAL_ADMIN",
    COPY_SINGLE_CELL_TO_CLIPBOARD: "COPY_SINGLE_CELL_TO_CLIPBOARD",
    COPY_TO_CLIPBOARD: "COPY_TO_CLIPBOARD",
    CREATE_API_KEY: "CREATE_API_KEY",
    COPY_DOC_LINK: "COPY_DOC_LINK",
    CREATE_LEGAL_CASES: "CREATE_LEGAL_CASES",
    CREATE_LEGAL_HOLD: "CREATE_LEGAL_HOLD",
    CSV_SYNCH: "CSV_SYNCH",
    DASHBOARDS_MANAGE: "DASHBOARDS_MANAGE",
    DASHBOARDS_VIEW: "DASHBOARDS_VIEW",
    DATA_STORE_MANAGE: "DATA_STORE_MANAGE",
    DATABASECONNECTION_MANAGE: "DATABASECONNECTION_MANAGE",
    DATASOURCE_MANAGE: "DATASOURCE_MANAGE",
    DEBUG: "DEBUG",
    DELETE_BPM_SERVER_MESSAGE: "DELETE_BPM_SERVER_MESSAGE",
    DELETE_EFORMS_SERVER_MESSAGE: "DELETE_EFORMS_SERVER_MESSAGE",
    DELETE_HSM_SERVER_MESSAGE: "DELETE_HSM_SERVER_MESSAGE",
    DELETE_IMPORTER_SERVER_MESSAGE: "DELETE_IMPORTER_SERVER_MESSAGE",
    DELETE_INDEXING_SERVER_MESSAGE: "DELETE_INDEXING_SERVER_MESSAGE",
    DELETE_LEGAL_CASES: "DELETE_LEGAL_CASES",
    DELETE_LICENSING_SERVER_MESSAGE: "DELETE_LICENSING_SERVER_MESSAGE",
    DELETE_REPOSITORIES_SERVER_MESSAGE: "DELETE_REPOSITORIES_SERVER_MESSAGE",
    DOC_CATEGORY_CREATE: "DOC_CATEGORY_CREATE",
    DOC_CATEGORY_DELETE: "DOC_CATEGORY_DELETE",
    DOC_CATEGORY_EDIT: "DOC_CATEGORY_EDIT",
    DOC_TYPE_CREATE: "DOC_TYPE_CREATE",
    DOC_TYPE_DELETE: "DOC_TYPE_DELETE",
    DOC_TYPE_EDIT: "DOC_TYPE_EDIT",
    DOC_TYPE_METADATA: "DOC_TYPE_METADATA",
    DOC_TYPE_SECURITY: "DOC_TYPE_SECURITY",
    DOCUMENT_DELETE: "DOCUMENT_DELETE",
    DOCUMENT_HIERARCHY: "DOCUMENT_HIERARCHY",
    DOCUMENT_INFO_PANEL: "DOCUMENT_INFO_PANEL",
    DOCUMENT_PURGE: "DOCUMENT_PURGE",
    DOCUMENT_RESTORE: "DOCUMENT_RESTORE",
    DOCUMENT_SEARCH: "DOCUMENT_SEARCH",
    DOWNLOAD_DOCUMENT: "DOWNLOAD_DOCUMENT",
    EDITING_CANCEL_ANY_EDIT: "EDITING_CANCEL_ANY_EDIT",
    EMAIL_ATTACHMENT: "EMAIL_ATTACHMENT",
    EXPORT_DOCUMENTS: "EXPORT_DOCUMENTS",
    EXPORTER_PROFILE_MANAGE: "EXPORTER_PROFILE_MANAGE",
    FAX_FAX: "FAX_FAX",
    FAX_MANAGE_FAX_SERVICES: "FAX_MANAGE_FAX_SERVICES",
    FAX_MANAGE_SERVERS: "FAX_MANAGE_SERVERS",
    FILE_UPLOAD: "FILE_UPLOAD",
    FOLDERS_MANAGE: "FOLDERS_MANAGE",
    FOLDERS_SHARE_GATEWAY: "FOLDERS_SHARE_GATEWAY",
    FOLDERS_ADMIN: "FOLDERS_ADMIN",
    FORM_DESIGN_ACTIVATE: "FORM_DESIGN_ACTIVATE",
    FORM_DESIGN_ASSIGN: "FORM_DESIGN_ASSIGN",
    FORM_DESIGN_DEACTIVATE: "FORM_DESIGN_DEACTIVATE",
    FORM_DESIGN_DELETE: "FORM_DESIGN_DELETE",
    FORM_DESIGN_EXPORT: "FORM_DESIGN_EXPORT",
    FORM_DESIGN_IMPORT: "FORM_DESIGN_IMPORT",
    FORM_DESIGN_UNLOCK: "FORM_DESIGN_UNLOCK",
    FORM_DESIGNER: "FORM_DESIGNER",
    FORM_INSTANCE_DELETE: "FORM_INSTANCE_DELETE",
    FORM_MANAGE: "FORM_MANAGE",
    FORMS: "FORMS",
    FULL_TEXT_PROCESSING: "FULL_TEXT_PROCESSING",
    GATEWAY_MESSAGES_MANAGE: "GATEWAY_MESSAGES_MANAGE",
    GATEWAYS_MANAGE: "GATEWAYS_MANAGE",
    GROUPS_CREATE: "GROUPS_CREATE",
    GROUPS_DELETE: "GROUPS_DELETE",
    GROUPS_EDIT: "GROUPS_EDIT",
    GROUPS_VIEW: "GROUPS_VIEW",
    HSM_DELETE: "HSM_DELETE",
    HSM_EDIT: "HSM_EDIT",
    HSM_START_STOP: "HSM_START_STOP",
    IMPORTER_CREATE: "IMPORTER_CREATE",
    IMPORTER_DELETE: "IMPORTER_DELETE",
    IMPORTER_EDIT: "IMPORTER_EDIT",
    IMPORTER_START_STOP: "IMPORTER_START_STOP",
    INDEX: "INDEX",
    INDEX_ALL: "INDEX_ALL",
    INDEX_REST: "INDEX_REST",
    INDEXING_CONFIG_MANAGE: "INDEXING_CONFIG_MANAGE",
    INTEGRATIONS: "THIRD_PARTY_INTEGRATION",
    LDAP_SYNCH: "LDAP_SYNCH",
    MANAGE_AUTHENTICATION: "MANAGE_AUTHENTICATION",
    MANAGE_CERTIFICATES: "MANAGE_CERTIFICATES",
    VIEW_SYSTEM_PERFORMANCE: "VIEW_SYSTEM_PERFORMANCE",
    MANAGE_GATEWAY_USERS: "MANAGE_GATEWAY_USERS",
    MANAGE_LICENSES: "MANAGE_LICENSES",
    MANAGE_LOGS: "MANAGE_LOGS",
    MANAGE_NOTE_TYPES: "MANAGE_NOTE_TYPES",
    MANAGE_RETENTION_POLICIES: "MANAGE_RETENTION_POLICIES",
    MANAGE_SERVER_SETTINGS: "MANAGE_SERVER_SETTINGS",
    MANAGE_SYSTEM_PROPERTIES: "MANAGE_SYSTEM_PROPERTIES",
    MANAGE_THEMES: "THEMES_MANAGE",
    MARKUP_MANAGE_OTHER: "MARKUP_MANAGE_OTHER",
    MARKUP_MANAGE_OWN: "MARKUP_MANAGE_OWN",
    METADATA_CREATE: "METADATA_CREATE",
    METADATA_DELETE: "METADATA_DELETE",
    METADATA_EDIT: "METADATA_EDIT",
    METADATA_VIEW: "METADATA_VIEW",
    NOTE_ENTRY: "NOTE_ENTRY",
    MANAGE_OTHER_NOTES: "MANAGE_OTHER_NOTES",
    OVERLAY_MANAGE: "OVERLAY_MANAGE",
    OVERRIDE_RETENTION_POLICIES: "OVERRIDE_RETENTION_POLICIES",
    PAGE_ROTATION_MANAGE: "PAGE_ROTATION_MANAGE",
    POINTER_CREATE: "POINTER_CREATE",
    PRINTFAX_MANAGE_DEVICES: "PRINTFAX_MANAGE_DEVICES",
    PRINTFAX_MANAGE_QUEUE: "PRINTFAX_MANAGE_QUEUE",
    PRINTFAX_MANAGE_SERVERS: "PRINTFAX_MANAGE_SERVERS",
    PRINTFAX_PRINT: "PRINTFAX_PRINT",
    RECEIVE_BATCH: "RECEIVE_BATCH",
    RECEIVE_JOB: "RECEIVE_JOB",
    RECORDS_SEARCH: "RECORDS_SEARCH",
    REDACTION_MANAGE_OTHER: "REDACTION_MANAGE_OTHER",
    REDACTION_MANAGE_OWN: "REDACTION_MANAGE_OWN",
    REINDEX: "REINDEX",
    RELEASE_LEGAL_HOLD: "RELEASE_LEGAL_HOLD",
    REPOSITORY_CREATE: "REPOSITORY_CREATE",
    REPOSITORY_DELETE: "REPOSITORY_DELETE",
    REPOSITORY_EDIT: "REPOSITORY_EDIT",
    REVOKE_LICENSE: "REVOKE_LICENSE",
    ROOT_USER: "ROOT_USER",
    SCAN: "SCAN",
    SCAN_SETTING_MANAGE: "SCAN_SETTING_MANAGE",
    SCAN_SHOW_UI: "SCAN_SHOW_UI",
    SCHEDULE_RETENTION_POLICIES: "SCHEDULE_RETENTION_POLICIES",
    SEARCH_EXPORT: "SEARCH_EXPORT",
    SEARCH_SAVE_AS_DOCUMENT: "SEARCH_SAVE_AS_DOCUMENT",
    SEARCHES_ASSIGN: "SEARCHES_ASSIGN",
    SEARCHES_CREATE: "SEARCHES_CREATE",
    SEARCHES_DELETE: "SEARCHES_DELETE",
    SEARCHES_EDIT: "SEARCHES_EDIT",
    STAMP_MANAGE_LIBRARY: "STAMP_MANAGE_LIBRARY",
    STAMP_MANAGE_OTHER: "STAMP_MANAGE_OTHER",
    STAMP_MANAGE_OWN: "STAMP_MANAGE_OWN",
    SYSTEM_TRANSFER_EXPORT: "SYSTEM_TRANSFER_EXPORT",
    SYSTEM_TRANSFER_IMPORT: "SYSTEM_TRANSFER_IMPORT",
    SWAGGER_API: "SWAGGER_API",
    UNINDEX: "UNINDEX",
    URL_API_ASSISTANT: "URL_API_ASSISTANT",
    USERS_CREATE: "USERS_CREATE",
    USERS_DELETE: "USERS_DELETE",
    USERS_EDIT: "USERS_EDIT",
    USERS_VIEW: "USERS_VIEW",
    VALIDATOR_MANAGE: "VALIDATOR_MANAGE",
    VERSIONING_REVERT: "VERSIONING_REVERT",
    VERSIONING_VIEW_PREVIOUS_VERSIONS: "VERSIONING_VIEW_PREVIOUS_VERSIONS",
    VIEW_AS_NATIVE: "VIEW_AS_NATIVE",
    VIEW_AS_PDF: "VIEW_AS_PDF",
    VIEW_BPM_SERVER_MESSAGE: "VIEW_BPM_SERVER_MESSAGE",
    VIEW_EFORMS_SERVER_MESSAGE: "VIEW_EFORMS_SERVER_MESSAGE",
    VIEW_HSM_SERVER_MESSAGE: "VIEW_HSM_SERVER_MESSAGE",
    VIEW_IMPORTER_SERVER_MESSAGE: "VIEW_IMPORTER_SERVER_MESSAGE",
    VIEW_INDEXING_SERVER_MESSAGE: "VIEW_INDEXING_SERVER_MESSAGE",
    VIEW_IN_ADAPTIVE_VIEWER: "VIEW_IN_ADAPTIVE_VIEWER",
    VIEW_IN_DF_VIEWER: "VIEW_IN_DF_VIEWER",
    VIEW_LICENSING_SERVER_MESSAGE: "VIEW_LICENSING_SERVER_MESSAGE",
    VIEW_REPOSITORIES_SERVER_MESSAGE: "VIEW_REPOSITORIES_SERVER_MESSAGE",
    WSDL_URL_CREATE: "WSDL_URL_CREATE",
    WSDL_URL_DELETE: "WSDL_URL_DELETE",
    WSDL_URL_VIEW: "WSDL_URL_VIEW"
};

export default FeatureRight;

// This is the collection of feature rights that can get you access to a document
export const DOCUMENT_RIGHTS = [
    FeatureRight.VIEW_AS_NATIVE,
    FeatureRight.VIEW_AS_PDF,
    FeatureRight.VIEW_IN_DF_VIEWER,
    FeatureRight.VIEW_IN_ADAPTIVE_VIEWER
];
